// import ModalForm from "./Form";
import StudentListForm from "./StudentListForm";
import { STUDENT, CITY, DATATABLE_EXPORT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const Schema = {
	components: { StudentListForm },

	data() {

		const currentPath = window.location.pathname;
		let statusParam = "student";
		let  btnDiscontinue = null;
		let btnReactive = null;
		if (currentPath.includes("new-student-list")) {
			statusParam = "new_student";
			btnDiscontinue = {
						title: 'Discontinue',
						icon: "refresh-ccw",
						type: "none",
          				className: 'btn btn-danger',
					};
		} else if (currentPath.includes("ex-student-list")) {
			statusParam = "ex-student";
			btnReactive = {
						title: 'Reactive',
						icon: "refresh-ccw",
						type: "none",
          				className: 'btn btn-success',
						hidden: statusParam !== 'ex-student', 
					};
		}else if (currentPath.includes("student-list")) {
			statusParam = "student";
			btnDiscontinue = {
						title: 'Discontinue',
						icon: "refresh-ccw",
						type: "none",
          				className: 'btn btn-danger',
					};
		}

		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: STUDENT,
			tableId: "student-list-table",
			formId: "student-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "Inquiry Date",
					type: "custom-html",
					key: "created_at",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: "CLC ID No",
					type: "custom-html",
					key: "clc_id_number",
					modifier: (value, row) => {
						return row.student_id || row.lead_id_number || row.clc_id_number || "-";
					},
				},
				{
					title: "Full Name",
					type: "text",
					key: "full_name",
				},
				{
					title: "Age",
					type: "custom-html",
					key: "age",
					modifier: (value) => {
						if (value) {
							return `<span>${value} years old</span>`;
						}
					},
				},
				{
					title: "Learning Program",
					type: "custom-html",
					isVisible: true,
					key: "learning_interests",
					modifier: (value) => {
						if (Array.isArray(value) && value.length > 0) {
							return value.join(", ");
						}

						if (typeof value === "string") {
							try {
								const parsed = JSON.parse(value);
								if (Array.isArray(parsed) && parsed.length > 0) {
									return parsed.join(", ");
								}
								return "";
							} catch (e) {
								return value;
							}
						}
						return "";
					},
				},
				{
					title: "Sub Status",
					type: "custom-html",
					key: "sub_status",
					isVisible: true,
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
								value.status
							)}</span>`;
						}
					},
				},
				{
					title: "Area of Residency",
					type: "custom-html",
					key: "area_of_residency",
					isVisible: true,
					modifier: (value) => {
						if (value && value.name) {
							return `<span>${this.$t(value.name)}</span>`;
						}
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "StudentListTable",
				url: `${STUDENT}?status=${statusParam}`,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					// {
					// 	title: this.$t("edit"),
					// 	icon: "edit",
					// 	type: "none",
					// 	component: "app-add-modal",
					// 	// component: "student-list-form",
					// 	modalId: "student-list-form",
					// },
					// {
					// 	title: "Parent Interview Form",
					// 	icon: "clipboard",
					// 	type: "page", // or "page" if you want to navigate to a new page
					// 	url: "/transaction/parent-interview", // Specify the URL you want to navigate to
					// 	target: "", // "_blank" if you want to open the URL in a new tab
					// 	uniqueKey: (rowData) => rowData.id,
					// 	disabled: (rowData) => this.isPifDisabled(rowData),
					// },
					{
						title: "Student Profile",
						icon: "user", // You can use an appropriate icon here
						type: "page", // or "page" if you want to navigate to a new page
						url: "/transaction/profile-student", // Specify the URL you want to navigate to
						target: "", // "_blank" if you want to open the URL in a new tab
						uniqueKey: (rowData) => rowData.id,
					},
					...(btnDiscontinue ? [btnDiscontinue] : []),
					...(btnReactive ? [btnReactive] : []),
					// {
					// 	title: this.$t("delete"),
					// 	icon: "trash",
					// 	type: "none",
					// 	component: "app-confirmation-modal",
					// 	modalId: "demo-delete",
					// },
				],
				filters: [
					// {
					// 	title: this.$t("Inquiry Date"),
					// 	type: "range-picker",
					// 	key: "created_at",
					// 	option: ["today", "thisMonth", "last7Days", "nextYear"],
					// },
					// {
					// 	title: this.$t("age"),
					// 	type: "range-filter",
					// 	key: "age",
					// 	maxTitle: this.$t("max_age"),
					// 	minTitle: this.$t("min_age"),
					// 	sign: "",
					// },
					// {
					// 	title: "Learning Program",
					// 	type: "checkbox",
					// 	key: "learning_interests",
					// 	option: [
					// 		{ id: "online_learning", value: "Online Learning" },
					// 		{
					// 			id: "on_site_learning",
					// 			value: "On-site learning",
					// 		},
					// 		{ id: "hybrid_learning", value: "Hybrid Learning" },
					// 		{ id: "clc_study_club", value: "CLC Study Club" },
					// 		{ id: "clc_apps", value: "CLC Apps" },
					// 		{ id: "other", value: "Other" },
					// 	],
					// },
					// {
					// 	title: "Sub Status",
					// 	type: "radio",
					// 	key: "sub_status.status",
					// 	option: [
					// 		{ id: "male", value: "Male" },
					// 		{ id: "female", value: "Female" },
					// 		{ id: "other", value: "Other" },
					// 	],
					// 	header: {
					// 		title: this.$t("want_to_filter_your_list"),
					// 		description: this.$t(
					// 			"you_can_filter_your_data_table_which_are_created_based_on_gender"
					// 		),
					// 	},
					// },
					// {
					// 	title: "Area of Residency",
					// 	type: "search-and-select-filter",
					// 	key: "city_id",
					// 	settings: {
					// 		url: `/${CITY}`, // this url will hit every search action
					// 		modifire: (v) => {
					// 			return { id: v.id, name: v.name };
					// 		},
					// 		per_page: 10, // default 10, you can change it any number. min 10 encourage to use
					// 		queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
					// 		loader: "app-pre-loader", // default app-overlay-loder
					// 		multiple: true, // default false, if you need to select multiple item so make it true
					// 		params: {
					// 			is_active: true,
					// 		}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
					// 	},
					// 	listValueField: "name",
					// },
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isPifDisabled(rowData) {
			if (rowData.status === "inactive") return true;
			else if (rowData.status === "not_interested") return true;
			else if (rowData.status === "invalid") return true;
			else return false;
		},
	},
};
